<section class="national-holiday">
  <app-hero [data]="data.hero"></app-hero>
  <app-timeline></app-timeline>
  <div class="wrapper">
    <div class="national-holiday-box">
      <ng-container *ngFor="let item of data.content">
        <article class="national-holiday-item" [ngClass]="{ less_margin: !item.title && !item.subTitle && item.body }">
          <div class="row">
            <div [ngClass]="item.thumbnail ? 'col-md-6' : 'col-12'">
              <h2 class="national-holiday-title" *ngIf="item.title">{{ item.title }}</h2>
              <h3 class="national-holiday-sub-title" *ngIf="item.subTitle"
                [ngStyle]="item.color && { 'border-color': item.color }">{{ item.subTitle }}</h3>
              <div class="national-holiday-body" [innerHTML]="item.body | safe: 'html'"></div>
            </div>
            <div class="col-md-6" *ngIf="item.thumbnail">
              <figure>
                <img [src]="item.thumbnail" [alt]="item.title" />
              </figure>
            </div>
          </div>
        </article>
      </ng-container>
    </div>
  </div>
</section>